import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, AlertController, NavController, LoadingController, Platform } from '@ionic/angular';
import { PlanoIosPageViewModel } from './PlanoIosPageViewModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { BasePage } from '../base.page';
import { InAppPurchase2, IAPProduct } from '@ionic-native/in-app-purchase-2/ngx';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { PlanoProvider } from 'projects/core/src/lib/core/provider/PlanoProvider';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { ContratoModel } from 'projects/core/src/lib/core/model/ContratoModel';
import { MessageService } from 'projects/core/src/lib/core/MessageService';
import { Browser } from '@capacitor/browser';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

@Component({
  selector: 'PlanoIosPage',
  templateUrl: 'PlanoIosPage.html',
  styleUrls: ['PlanoIosPage.scss']
})
export class PlanoIosPage extends BasePage {

  constructor(
    public router: Router, 
    private iap: InAppPurchase2,
    public modalCtrl: ModalController,
    public alertController: AlertController,
    public navCtrl: NavController,
    public loadingController: LoadingController,
    public platform: Platform){
      super(router)
  }

  urlTermos: string = "https://app.phicube.com.br/termos.pdf"
  urlPrivacidade: string = 'https://app.phicube.com.br/privacidade.pdf'
  plans
  logCucesso = ""
  contratos: Array<ContratoModel> = []
  _self
  planoSelecionado = null
  loadingGeral = null
  tentativaErroAssociate = 0

  loadingComponent: LoadingComponent
  viewModel: PlanoIosPageViewModel
  alertComponent: AlertComponent
  planoProvider: PlanoProvider

  async ngOnInit() {
    this.iniciaVariaveis()
    this.platform.ready().then(() => {
      this.getProducts()
    })
  }

  async iniciaVariaveis() {
    this.viewModel = new PlanoIosPageViewModel()
    this.viewModel.setContext(this)
    this.loadingComponent = new LoadingComponent(this.loadingController)

    const user: UsuarioModel = await AppSession.getUser()
    this.planoProvider = new PlanoProvider(user.admin)
    this.plans = await this.planoProvider.listPlanos()
  }

  async getProducts() {
    this.loadingGeral = await this.showLoading()
    const _self = this
    try {
      await this.buscaContratos()

      _self.planoProvider.configPlanosInApp(this.iap)

      await this.readIap()
      await this.setIdUserInAppPurchase()

      this.plans = this.plans.filter((valuePlan) => {
        for (let valueProduct of this.iap.products) {
          if (valuePlan.idApple == valueProduct.id) {
            valuePlan.preco = valueProduct.price
            valuePlan.name = valueProduct.title
            valuePlan.disabled = _self.verificaJaPossuiPlano(valuePlan.chavesContrato) || !valueProduct.canPurchase
            return true
          }
        }
        return false
      })

      this.iap.when("product").approved(async function(product: IAPProduct) {
        FirebaseCrashlytics.recordException({message: `getProducts listeners - Approved - ${JSON.stringify(product)}`})

        product.verify().done((productVerify: IAPProduct) => {
          FirebaseCrashlytics.recordException({message: `getProducts listeners - Verified - ${JSON.stringify(productVerify)}`})
          
        }).expired((productVerify: IAPProduct) => {
          FirebaseCrashlytics.recordException({message: `getProducts listeners - Expired - ${JSON.stringify(productVerify)}`})
          
        }).success(async (productVerify: IAPProduct, purchaseData) => {
          FirebaseCrashlytics.recordException({message: `getProducts listeners - Success Begin - ${JSON.stringify(productVerify)}`})
          FirebaseCrashlytics.recordException({message: `getProducts listeners - Success Validated - ${JSON.stringify({
            "_self.planoSelecionado": _self.planoSelecionado,
            "productVerify.id": productVerify.id,
            "productVerify.transaction.original_transaction_id": productVerify.transaction.original_transaction_id,
            "100char_productVerify.transaction.appStoreReceipt": productVerify.transaction.appStoreReceipt.substr(0, 100)
          })}`})
          if (
            productVerify.transaction.appStoreReceipt != null
          ) {
            await _self.associateApple(productVerify)
          }
        }).error((err) => {
          FirebaseCrashlytics.recordException({message: `Erro em getProducts - Compra - ${JSON.stringify(err)}`})
          if (_self.loadingGeral) _self.loadingGeral.dismiss()
        })
      });

      this.iap.error(function(e){
        FirebaseCrashlytics.recordException({message: `Erro em getProducts - Listeners - ${JSON.stringify(e)}`})
        if (_self.loadingGeral) _self.loadingGeral.dismiss()
        this.showAlert(ThrowError.TITLE_DEFAULT, "ERROR " + e.code + ": " + e.message);
      });
    } catch(e) {
      FirebaseCrashlytics.recordException({message: `Erro em getProducts - ${JSON.stringify(e)}`})
      this.showAlert(ThrowError.TITLE_DEFAULT, `Não foi possível carregar as informações de plano no momento. Tente novamente. ${JSON.stringify(e)}`)
      this.fecharTela()
    }
    if (this.loadingGeral != null) {
      this.loadingGeral.dismiss()
    }
  }

  disabledPlan(idApple) {
    this.plans.forEach((value, index) => {
      if (value.idApple == idApple) {
        value.disabled = true
      }
    });
  }

  async setIdUserInAppPurchase() {
    const retorno = await AppSession.getUser()
    this.iap.applicationUsername = retorno.id
  }

  async associateApple(product: IAPProduct) {
    FirebaseCrashlytics.recordException({message: `associateApple - Begin. - ${JSON.stringify({
      id: product.transaction.id,
      original_transaction_id: product.transaction.original_transaction_id
    })}`})
    try {
      const retorno = await this.viewModel.associateApple(product.transaction.id, product.transaction.appStoreReceipt)
      FirebaseCrashlytics.recordException({message: `associateApple - API response ${JSON.stringify(retorno)}`})
      if (retorno) {
        this.disabledPlan(product.id)
        this.tentativaErroAssociate = 0
        if (this.loadingGeral) this.loadingGeral.dismiss()
        this.fecharTela()
        setTimeout(() => {
          MessageService.sendMessage(MessageService.KEY_LOGIN, "forcar_buscar_contrato")
        }, 500)
        FirebaseCrashlytics.recordException({message: `associateApple - OK`})
        product.finish();//Necessário para Apple liberar o dinheiro?
        FirebaseCrashlytics.recordException({message: `IAP finish - OK`})
      }
    } catch(e) {
      FirebaseCrashlytics.recordException({message: 'Erro Tentando Associar: '+this.tentativaErroAssociate})
      if (this.tentativaErroAssociate < 3) {
        this.associateApple(product)
        this.tentativaErroAssociate++
      } else { // redirecionar o usuário?
        if (this.loadingGeral) this.loadingGeral.dismiss()
      }
    }
  }

  verificaJaPossuiPlano(chavesContrato): boolean {
    for (let contrato of this.contratos) {
      if (chavesContrato.indexOf(contrato.chave) >= 0 && contrato.acesso_liberado) {
        return true
      }
    }
    return false
  }

  async readIap() {
    return new Promise((resolve, reject) => {
      this.iap.ready((state) => {
        resolve(state)
      })
    })
  }

  processProductApi(codPlano, idApple, status = PlanoProvider.STATUS_COMPRA_EFETUADA, product) {
    try {
      this.viewModel.confirmPurchaseApi(
        codPlano,
        status,
        idApple,
        product
      )
    } catch(e) {
      FirebaseCrashlytics.recordException({message: `Erro ProcessProductApi. codPlano: ${codPlano}. idAppe: ${idApple}. status: ${status}. product: ${JSON.stringify(product)}` })
      this.showAlert(ThrowError.TITLE_DEFAULT, "Não foi possível confirmar seu plano no momento. Tente novamente.")
      this.navCtrl.pop();
    }
  }

  async buscaContratos() {
    const retorno = await this.viewModel.apiBuscaContratos()
    this.contratos = retorno.contratos
  }

  async showAlert(title: string, message: string, handler?): Promise<HTMLIonAlertElement> {
    return await AlertComponent.showAlert(title, message, handler)
  }

  getTodosIdApple() {
    const aux = []
    for (let plan of this.plans) {
      aux.push(plan.idApple)
    }
    return aux
  }

  contratarPlano(productId) {
    this.planoSelecionado = productId
    const _self = this

    this.iap.order(productId).then(async () => {
      _self.loadingGeral = await this.showLoading()
    }).error((err) => {
      FirebaseCrashlytics.recordException({message: `Erro contratarPlano. productId ${productId}.` })
      if (_self.loadingGeral) _self.loadingGeral.dismiss()
      this.showAlert(ThrowError.TITLE_DEFAULT, "ERRO CONTRATAR: " + JSON.stringify(err))
    })
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  clickAtualizar() {
    
  }

  fecharTela() {
    this.navCtrl.back();
  }

  clickLinkTermos() {
    this.abreLinkExterno(this.urlTermos)
  }

  clickLinkPoliticaPrivacidade() {
      this.abreLinkExterno(this.urlPrivacidade)
  }

  async abreLinkExterno(url: string) {
    await Browser.open({ url });
  }
}
